import {
  createSlice,
  createAsyncThunk,
  createEntityAdapter,
} from '@reduxjs/toolkit';
import { normalize, schema } from 'normalizr';
import reportFirestore from 'network/reportFirestore';

export const userActivityLogEntity = new schema.Entity('userActivityLog');

const userActivityLogAdapter = createEntityAdapter({
  sortComparer: (a: any, b: any) => b.action_at.toMillis() - a.action_at.toMillis(),
});

export const {
  selectAll: selectAllUserActivityLog,
} = userActivityLogAdapter.getSelectors((state: any) => state.userActivityLog);

export const selectFetchingUserActivityLog = (state) => state.userActivityLog.fetching;

export const userActivityLogSlice = createSlice({
  name: 'userActivityLog',
  initialState: userActivityLogAdapter.getInitialState({ fetching: true }),
  reducers: {
    upsertLogs(state, action) {
      userActivityLogAdapter.upsertMany(state, action.payload);
    },
    batchUpdateLogs(state, action) {
      userActivityLogAdapter.setAll(state, action.payload);
    },
    setFetching(state, action) {
      state.fetching = action.payload;
    },
  },
});

export const {
  upsertLogs,
  batchUpdateLogs,
  setFetching,
} = userActivityLogSlice.actions;

export default userActivityLogSlice.reducer;
